import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { path, is } from 'ramda';

import { MIN_COLUMN_WIDTH } from 'constants/defaultColumns';
import { isTouchDevice } from 'utils/system';

const isNumber = is(Number);

export default class TableHeaderResize extends Component {
    static propTypes = {
        handleColumnResize: PropTypes.func.isRequired,
        columnName: PropTypes.string.isRequired
    };

    render() {
        return (
            <div ref={node => this.element = node} className={'table-resize-knob'}>
                <div className={'table-resize-stick'} />
            </div>
        );
    }

    componentWillUnmount() {
        this.clearElementEvents();
    }

    clearDocumentEvents() {
        document.removeEventListener('mousemove', this.watchMouseMove);
        document.removeEventListener('touchmove', this.watchMouseMove);
        document.removeEventListener('mouseleave', this.endResize);
        document.removeEventListener('mouseup', this.endResize);
        document.removeEventListener('touchend', this.endResize);
    }

    clearElementEvents() {
        this.element.removeEventListener("mousedown", this.startResize);
        this.element.removeEventListener("touchstart", this.startResize);
    }

    componentDidMount() {
        this.stick = this.element.firstChild;
        this.stickDefault = this.stick.style.right;

        this.element.addEventListener("mousedown", this.startResize);
        this.element.addEventListener("touchstart", this.startResize);
    }

    startResize = () => {
        this.clear();

        this.element.classList.add('active');

        document.addEventListener('mousemove', this.watchMouseMove);
        document.addEventListener('touchmove', this.watchMouseMove);
        document.addEventListener('mouseleave', this.endResize);
        document.addEventListener('mouseup', this.endResize);
        document.addEventListener('touchend', this.endResize);
    }

    watchMouseMove = (evt) => {
        const touchClientX = path(['originalEvent', 'touches', '0', 'clientX'], evt);
        const clientX = isTouchDevice() && isNumber(touchClientX) ? touchClientX : evt.clientX;

        if (!isNumber(clientX) || !this.element) return;

        let resizeShift = clientX - this.element.getBoundingClientRect().right;

        if (this.currentWidth + resizeShift < MIN_COLUMN_WIDTH) {
            resizeShift = MIN_COLUMN_WIDTH - this.currentWidth;
        }

        this.newWidth = resizeShift + this.currentWidth;

        this.stick.style.right = (this.stickDefault + (-resizeShift)) + 'px';
    }

    endResize = () => {
        const { handleColumnResize, columnName } = this.props;
        const columnWidth = Math.max(this.newWidth, MIN_COLUMN_WIDTH);

        if (!this.element) return;

        handleColumnResize({ columnName, columnWidth });

        this.element.classList.remove('active');
        this.clearDocumentEvents();
        this.clear();
    }

    clear() {
        this.currentWidth = parseInt(getComputedStyle(this.element.parentElement).width, 10);
        this.newWidth = this.currentWidth;
        this.stick.style.right = this.stickDefault;
    }
}
